function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M11.81,24H2.5A2.5,2.5,0,0,1,0,21.5V2.5A2.5,2.5,0,0,1,2.5,0h13A2.5,2.5,0,0,1,18,2.5V15.09A6.64,6.64,0,0,0,17,15V2.5A1.5,1.5,0,0,0,15.5,1H2.5A1.5,1.5,0,0,0,1,2.5v19A1.5,1.5,0,0,0,2.5,23h8.85A6,6,0,0,0,11.81,24Zm-.72-4H2.5a.5.5,0,0,1-.5-.5V3.5A.5.5,0,0,1,2.5,3h13a.5.5,0,0,1,.5.5V15.09a5.65,5.65,0,0,0-1,.26V4H3V19h8.35A5.65,5.65,0,0,0,11.09,20ZM9,1.5a.5.5,0,1,1-.5.5A.5.5,0,0,1,9,1.5Zm8,26A6.5,6.5,0,1,1,23.5,21,6.51,6.51,0,0,1,17,27.5Zm0-12A5.5,5.5,0,1,0,22.5,21,5.51,5.51,0,0,0,17,15.5Zm-.5,8.34a.51.51,0,0,1-.35-.15l-2.5-2.5a.5.5,0,0,1,0-.71.5.5,0,0,1,.7,0l2.13,2.13,3.15-3.45a.5.5,0,1,1,.74.68l-3.5,3.83a.53.53,0,0,1-.36.17Z"
})));

var SvgDevices = function SvgDevices(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.5 27.5",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDevices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/devices.ce7f92e7.svg";
export { ForwardRef as ReactComponent };